import { parseDate } from "./utils";

/* Blocked / overdue — the ONE definition shared by the stage page's attention
   tiles (useStageStats) and the pipeline rail's per-stage chips (PipelineRail),
   so the two can never disagree about what counts. */

// Midnight today — overdue means the due date is strictly before today.
export function startOfToday() {
  const t = new Date();
  t.setHours(0, 0, 0, 0);
  return t;
}

export function isItemBlocked(item) {
  return !!item.is_blocked;
}

// Dispatch due date wins over the PO due date (same order everywhere).
export function isItemOverdue(item, today = startOfToday()) {
  const d = parseDate(item.dispatch_due_date || item.due_date);
  return !!(d && d < today);
}
